// state
const state = {
  // 是否显示侧边栏
  showAside: false,
  // 当前工作台
  currentWorkbench: {},
  myWorkbenchId: null,
  appMenu: [],
  expandedMenu: [],
  appDepthMenu: [],
  dataList: [],
  normalAppList: [],
  domainData: {},
  popperShow: false,
  openedAppIds: JSON.parse(localStorage.getItem('openedAppIds') || '[]')
}
// mutations
const mutations = {
  // 设置是否显示侧边栏
  SET_SHOW_ASIDE: (state, showAside) => {
    state.showAside = showAside
  },
  // 设置当前工作台
  SET_CURRENT_WORKBENCH: (state, currentWorkbench) => {
    state.currentWorkbench = currentWorkbench
  },
  // 设置我的
  SET_MY_WORKBENCH: (state, id) => {
    state.myWorkbenchId = id
  },
  // 设置子应用菜单
  SET_APP_MENU: (state, menu) => {
    state.appMenu = menu
  },
  // 设置子应用展开的目录
  SET_EXPANDED_MENU: (state, menu) => {
    state.expandedMenu = menu
  },
  // 设置子应用内部菜单
  SET_APP_DEPTHMENU: (state, menu) => {
    state.appDepthMenu = menu
  },
  // 设置弹出框显示状态
  SET_POPPER_SHOW: (state, popperShow) => {
    state.popperShow = popperShow
  },
  // 设置常用应用列表
  SET_NORMAL_APPLIST: (state, appList) => {
    state.normalAppList = appList
  },
  // 设置常用应用列表
  SET_DATA_LIST: (state, appList) => {
    state.dataList = appList
  },
  // 设置常用应用列表
  SET_DOAMIN_DATA: (state, domainData) => {
    state.domainData = domainData
  },
  // 设置打开的应用Id
  ADD_OPENED_APPIDS: (state, openedAppId) => {
    // 判断是否已存在相同context的应用
    const exists = state.openedAppIds.some(app => app === openedAppId)
    // 如果不存在相同context的应用，则添加
    if (!exists) {
      state.openedAppIds.push(openedAppId)
      localStorage.setItem('openedAppIds', JSON.stringify(state.openedAppIds))
    }
  },
  CLEAR_OPENED_APPIDS: (state) => {
    state.openedAppIds = []
    localStorage.setItem('openedAppIds', JSON.stringify(state.openedAppIds))
  }
}

// 请求
const actions = {
  /**
   * 更新显示侧边栏
   */
  updateShowAside({ commit }, showAside) {
    // 设置是否显示侧边栏
    commit('SET_SHOW_ASIDE', showAside)
  },
  /**
   * 更新显示子应用菜单
   */
  updateAppMenu({ commit }, menu) {
    commit('SET_APP_MENU', menu)
  },
  /**
   * 更新显示子应用展开的目录
   */
  updateExpandedMenu({ commit }, menu) {
    commit('SET_EXPANDED_MENU', menu)
  },
  /**
     * 更新显示子应用内部菜单
     */
  updateAppDepthMenu({ commit }, menu) {
    commit('SET_APP_DEPTHMENU', menu)
  },
  /**
   * 更新当前工作台
   */
  updateCurrentWorkbench({ commit }, currentWorkbench) {
    commit('SET_CURRENT_WORKBENCH', currentWorkbench)
  },
  /**
   * 更新我的工作台
   */
  updateDesignWorkbench({ commit }, id) {
    commit('SET_MY_WORKBENCH', id)
  },
  // 设置popper显示状态
  setPopperShow({ commit }, popperShow) {
    commit('SET_POPPER_SHOW', popperShow)
  },
  // 设置常用应用列表
  setNormalAppList({ commit }, appList) {
    commit('SET_NORMAL_APPLIST', appList)
  },
  // 设置应用分组列表
  setDataList({ commit }, appList) {
    commit('SET_DATA_LIST', appList)
  },
  // 设置应用分组列表
  setDomainData({ commit }, domainData) {
    commit('SET_DOAMIN_DATA', domainData)
  },
  // 设置应用分组列表
  addOpenedAppIds({ commit }, openedAppId) {
    commit('ADD_OPENED_APPIDS', openedAppId)
  },
  // 设置应用分组列表
  clearOpenedAppIds({ commit }) {
    commit('CLEAR_OPENED_APPIDS')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
